import { POST, SUCCESS } from "../../utils/const/http-const";
import { getHeaders } from "../utils";


export async function obtenerHistoricoRuta(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apirastreogestion/api/historico/obtener-historico",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerHistoricoRuta err");
        console.log(err);
        return [];
    }
}